/** Variáveis do catálogo referenciadas pelas condições de exibição de um formulário. */
import { CondicaoAtomica, Condicao, ehGrupo, itensDoGrupo } from './tipos'
import { CampoFormularioBase } from './esquema'

const coletar = (condicao: Condicao | null | undefined, destino: Set<string>): void => {
  if (!condicao) return
  if (ehGrupo(condicao)) {
    itensDoGrupo(condicao).forEach((item) => coletar(item, destino))
    return
  }
  const atomica = condicao as CondicaoAtomica
  if (atomica.fonte === 'variavel' && atomica.ref) destino.add(atomica.ref)
}

/** Códigos deduplicados e ordenados, para o painel "Simular dados do paciente". */
export const variaveisUsadas = (campos: CampoFormularioBase[]): string[] => {
  const usadas = new Set<string>()
  campos.forEach((campo) => coletar(campo.condicaoExibicao, usadas))
  return Array.from(usadas).sort()
}
